const SLUG_RE = /^[a-z0-9][a-z0-9-]{1,62}$/;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const ROUTAGE_BOUTIQUECLUB_INITIAL = Object.freeze({
  groupes: [
    {
      code: 'FORQUET', slug: 'forquet', nom_public: 'Groupe FORQUET', actif: true,
      magasins: [
        { code: 'ARB', slug: 'arb', nom_public: "L’Arbresle", actif: true },
        { code: 'LYON', slug: 'lyon', nom_public: 'Lyon Confluence', actif: true },
      ],
    },
  ],
});

export const normaliserSlugPublic = (valeur) => String(valeur || '').trim().toLowerCase();
export const slugPublicValide = (valeur) => SLUG_RE.test(normaliserSlugPublic(valeur));

export function indexerRoutagePublic(configuration = ROUTAGE_BOUTIQUECLUB_INITIAL) {
  const groupes = new Map();
  const magasins = new Map();
  const erreurs = [];
  (configuration.groupes || []).forEach((groupe) => {
    const slug = normaliserSlugPublic(groupe.slug);
    if (!slugPublicValide(slug)) erreurs.push(`Slug groupe invalide : ${slug || 'vide'}`);
    else if (groupes.has(slug) || magasins.has(slug)) erreurs.push(`Slug public dupliqué : ${slug}`);
    else groupes.set(slug, { ...groupe, slug });
    (groupe.magasins || []).forEach((magasin) => {
      const magasinSlug = normaliserSlugPublic(magasin.slug);
      if (!slugPublicValide(magasinSlug)) erreurs.push(`Slug magasin invalide : ${magasinSlug || 'vide'}`);
      else if (groupes.has(magasinSlug) || magasins.has(magasinSlug)) erreurs.push(`Slug public dupliqué : ${magasinSlug}`);
      else magasins.set(magasinSlug, { ...magasin, slug: magasinSlug, groupe_slug: slug, groupe_code: groupe.code });
    });
  });
  return { groupes, magasins, erreurs };
}

export function resoudreRouteBoutiqueClub(pathname, configuration = ROUTAGE_BOUTIQUECLUB_INITIAL) {
  const segments = String(pathname || '/').split('/').filter(Boolean).map(normaliserSlugPublic);
  if (segments.length === 2 && segments[0] === 'paiement' && segments[1] === 'retour') return { type:'PAIEMENT_RETOUR' };
  if (segments.length === 2 && segments[0] === 'paiement' && segments[1] === 'annule') return { type:'PAIEMENT_ANNULE' };
  const index = indexerRoutagePublic(configuration);
  if (index.erreurs.length) return { type: 'ERREUR_CONFIGURATION', erreurs: index.erreurs };
  if (!segments.length) return { type: 'PORTAIL' };
  const racine = segments[0];
  const magasin = index.magasins.get(racine);
  const groupe = index.groupes.get(racine) || (magasin ? index.groupes.get(magasin.groupe_slug) : null);
  if (!groupe || groupe.actif === false || (magasin && magasin.actif === false)) return { type: 'INTROUVABLE' };
  const contexte = magasin
    ? { groupeSlug: magasin.groupe_slug, magasinSlug: magasin.slug, magasin, groupe }
    : { groupeSlug: groupe.slug, magasinSlug: null, magasin: null, groupe };
  if (segments.length === 1) return { type: magasin ? 'MAGASIN' : 'GROUPE', ...contexte };
  if (segments[1] === 'club' && segments.length === 3 && UUID_RE.test(segments[2])) return { type: 'CLUB', clubId: segments[2], ...contexte };
  if (segments[1] === 'campagne' && UUID_RE.test(segments[2])) {
    if (segments.length === 3) return { type: 'CAMPAGNE', campagneId: segments[2], ...contexte };
    if (segments.length === 5 && segments[3] === 'pack' && UUID_RE.test(segments[4])) return { type: 'PACK', campagneId: segments[2], packId: segments[4], ...contexte };
  }
  return { type: 'INTROUVABLE' };
}

export function urlBoutiqueClub({ groupeSlug, magasinSlug, clubId, campagneId, packId } = {}) {
  const racine = normaliserSlugPublic(magasinSlug || groupeSlug);
  if (!racine) return '/';
  if (packId && campagneId) return `/${racine}/campagne/${campagneId}/pack/${packId}`;
  if (campagneId) return `/${racine}/campagne/${campagneId}`;
  if (clubId) return `/${racine}/club/${clubId}`;
  return `/${racine}`;
}

export function estHotePortailBoutiqueClub(hostname = '', env = process.env) {
  const hote = String(hostname).toLowerCase();
  return env.REACT_APP_BOUTIQUECLUB_PUBLIC_ROOT === 'true' || hote === 'crmboutique.fr' || hote === 'www.crmboutique.fr';
}
